import axios from './axios';
import { DeliveryOrder } from '../store/config/types/deliveryOrders.types';

async function fetchDeliveryOrders(): Promise<DeliveryOrder[] | undefined> {
  const res = await axios.get('/delivery_orders');
  return res.data.data;
}

export const deliveryOrdersService = { fetchDeliveryOrders };
